function toggleQuickCart(productId, addToCartContent) {
  const quickCart = $(`#quick-add-area-${productId}`);
  const icon = $(`#btn-cart-toggle-${productId} span.btn-quick-add-icon`);

  if (quickCart) {
    if (quickCart.hasClass('show')) {
      icon.text('+');
      quickCart.removeClass('show');
    } else {
      $('.quick-add-product-dropdown-content').removeClass('show');
      icon.text('-');
      quickCart.addClass('show');
    }
  }
}

//add event submit for all form have class `.form.form__quick-add`to html
// async function quickAddToCart(event) {
//   event.preventDefault();
//   //get form from event
//   const form = event.target;
//   const button = event.submitter;
//   $(button).addClass('add-active');
//   $(button).find('.loading__spinner').removeClass('hidden');

//   //submit form here with fetch, if successful refresh cart drawer
//   const response = await fetch(form.action, {
//     method: form.method,
//     body: new FormData(form),
//   });

//   if (response.ok) {
//     $('#popup').addClass('show');
//   }
//   $(button).removeClass('add-active');
//   $(button).find('.loading__spinner').addClass('hidden');
// }

async function quickAddToCart(formId) {
  var form = document.getElementById(formId);

  const button = $(form).find('.add-to-cart');
  $(button).addClass('add-active');
  $(button).find('.loading__spinner').removeClass('hidden');

  //submit form here with fetch, if successful refresh cart drawer
  const response = await fetch(form.action, {
    method: form.method,
    body: new FormData(form),
  });

  if (response.ok) {
    $('#popup').addClass('show');
    $.getJSON('/cart.js', updateBubbleCart);
  }
  $(button).removeClass('add-active');
  $(button).find('.loading__spinner').addClass('hidden');
}

function updateBubbleCart(cart) {
  const cartCountSelector = '.cart-count-bubble > span';
  if ($(cartCountSelector).length) {
    var value = $(cartCountSelector).html() || '0';

    console.log(value);

    $(cartCountSelector)
      .html(value.replace(/[0-9]+/, cart.item_count))
      .removeClass('hidden-count');
  } else {
    const icon = `<span class="svg-wrapper"><svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-cart" viewBox="0 0 40 40"><path fill="currentColor" fill-rule="evenodd" d="M20.5 6.5a4.75 4.75 0 0 0-4.75 4.75v.56h-3.16l-.77 11.6a5 5 0 0 0 4.99 5.34h7.38a5 5 0 0 0 4.99-5.33l-.77-11.6h-3.16v-.57A4.75 4.75 0 0 0 20.5 6.5m3.75 5.31v-.56a3.75 3.75 0 1 0-7.5 0v.56zm-7.5 1h7.5v.56a3.75 3.75 0 1 1-7.5 0zm-1 0v.56a4.75 4.75 0 1 0 9.5 0v-.56h2.22l.71 10.67a4 4 0 0 1-3.99 4.27h-7.38a4 4 0 0 1-4-4.27l.72-10.67z"></path></svg> </span>`;
    const htmlBubble = `<div class='cart-count-bubble'><span aria-hidden='true'>${cart.item_count}</span></div>`;
    //remove all element in cart-icon-bubble
    $('#cart-icon-bubble').empty();
    $('#cart-icon-bubble').append($(icon));
    $('#cart-icon-bubble').append($(htmlBubble));
  }
}

document.addEventListener('DOMContentLoaded', () => {
  $('.form__quick-add').on('submit', quickAddToCart);

  // Operation when clicking the "See Cart" button
  $('#view-cart').on('click', function () {
    // Added processing to the cart page (eg, transition to the cart page by Window.location.href)
    window.location.href = '/cart'; // Changed to the URL of the cart page
  });

  // Click the "Continue shopping" button, close the pop -up
  $('#continue-shopping').on('click', function () {
    // Close pop -up
    $('#popup').removeClass('show');
    $('.quick-add-product-dropdown-content').removeClass('show');
  });

  // Close when you click the pop -up background part (overlay)
  $('#popup').on('click', function (e) {
    // Close only when you click outside the pop -up content (background part)
    if ($(e.target).is(this)) {
      $(this).hide();
    }
  });
});
